import qs from 'query-string'
import { getRequest } from 'api/fetcher'
import {
  MapQueryParams,
  ProviderType,
  UnreportedPlaceCandidate,
} from 'infra/type'

type ExternalSearchProvider = Extract<ProviderType, 'kakao' | 'naver'>

interface ExternalSearchResponse {
  places: UnreportedPlaceCandidate[]
}

export const searchExternalPlaces = async (
  provider: ExternalSearchProvider,
  params: MapQueryParams,
): Promise<UnreportedPlaceCandidate[]> => {
  const response = await getRequest<ExternalSearchResponse>(
    `/places/external-search/${provider}?${qs.stringify(params)}`,
  )
  return response.data?.places ?? []
}
